<template>
	<div class="spinner--square" :id="uid" v-if="variant === 'square'">
		<div class="spinner--square__cube"></div>
		<div class="spinner--square__cube"></div>
		<div class="spinner--square__cube"></div>
		<div class="spinner--square__cube"></div>
		<div class="spinner--square__cube"></div>
		<div class="spinner--square__cube"></div>
		<div class="spinner--square__cube"></div>
		<div class="spinner--square__cube"></div>
		<div class="spinner--square__cube"></div>
	</div>
	<div
		class="spinner--infinity-scroll"
		:id="uid"
		v-else-if="variant === 'infinity-scroll'"
	>
		<div class="spinner--infinity-scroll__dot"></div>
		<div class="spinner--infinity-scroll__dot"></div>
		<div class="spinner--infinity-scroll__dot"></div>
		<div class="spinner--infinity-scroll__dot"></div>
		<div class="spinner--infinity-scroll__dot"></div>
		<div class="spinner--infinity-scroll__dot"></div>
	</div>
	<div class="spinner--buttons" :id="uid" v-else-if="variant === 'buttons'">
		<div class="spinner--buttons__dots">
			<div class="spinner--buttons__dot"></div>
			<div class="spinner--buttons__dot"></div>
			<div class="spinner--buttons__dot"></div>
		</div>
	</div>
	<div class="spinner--diamond" :id="uid" v-else>
		<div class="spinner--diamond__cube1"></div>
		<div class="spinner--diamond__cube2"></div>
		<div class="spinner--diamond__cube4"></div>
		<div class="spinner--diamond__cube3"></div>
	</div>
</template>

<script>
export default {
	name: 'SpinnerVue'
};
</script>

<style lang="scss" scoped>
/**
    * [Description]
    *
    * Spinner VUE
    * Can use SCSS variables = TRUE
    *
    * All spinner styles and variations are included here.
    *
    * [Table of Contents]
    *
    * SQUARE SPINNER
    * DIAMOND SPINNER
    * INFINITY SCROLL SPINNER
	* DOTS BUTTON SPINNER
 */

/*------------------------------------*\
  #SQUARE SPINNER
\*------------------------------------*/

$base-duration: 500ms;

.spinner--square {
	position: relative;
	display: grid;
	grid-template-columns: 33% 33% 33%;
	grid-gap: 2px;
	width: 50px;
	height: 50px;

	&__cube {
		position: relative;
		width: 100%;
		height: 100%;
		background: tomato;
		transform: scale(0);
		transform-origin: center center;
		animation: scaleCubeAnim 2s infinite linear;

		&:nth-of-type(7) {
			background: #ec1c24;
		}

		&:nth-of-type(1),
		&:nth-of-type(5),
		&:nth-of-type(9) {
			animation-delay: 0.4s;
			background: #009245;
		}

		&:nth-of-type(4),
		&:nth-of-type(8) {
			animation-delay: 0.2s;
			background: #8cc63f;
		}

		&:nth-of-type(2),
		&:nth-of-type(6) {
			animation-delay: 0.6s;
			background: #296f0f;
		}

		&:nth-of-type(3) {
			animation-delay: 0.8s;
			background: #296f0f;
		}
	}
}

@keyframes scaleCubeAnim {
	0% {
		transform: scale(0);
	}
	40% {
		transform: scale(1);
	}
	80% {
		transform: scale(1);
	}
	100% {
		transform: scale(0);
	}
}

/*------------------------------------*\
  #DIAMOND SPINNER
\*------------------------------------*/

.spinner--diamond {
	margin: 20px auto;
	width: 40px;
	height: 40px;
	transform: translateX(-50%) + rotateZ(45deg);
	position: fixed;
	left: 50%;
	top: 50%;

	&__cube1 {
		background: #fff;
	}

	&__cube2 {
		background: #009245;
	}

	&__cube3 {
		background: #8cc63f;
	}

	&__cube4 {
		background: #ec1c24;
	}

	&__cube1,
	&__cube2,
	&__cube3,
	&__cube4 {
		float: left;
		width: 50%;
		height: 50%;
		position: relative;
		-webkit-transform: scale(1.1);
		-ms-transform: scale(1.1);
		transform: scale(1.1);

		&:before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: #296f0f;
			-webkit-animation: foldCubeAnim 2.4s infinite linear both;
			animation: foldCubeAnim 2.4s infinite linear both;
			-webkit-transform-origin: 100% 100%;
			-ms-transform-origin: 100% 100%;
			transform-origin: 100% 100%;
		}
	}

	// transform
	&__cube2 {
		-webkit-transform: scale(1.1) rotateZ(90deg);
		transform: scale(1.1) rotateZ(90deg);
	}
	&__cube3 {
		-webkit-transform: scale(1.1) rotateZ(180deg);
		transform: scale(1.1) rotateZ(180deg);
	}
	&__cube4 {
		-webkit-transform: scale(1.1) rotateZ(270deg);
		transform: scale(1.1) rotateZ(270deg);
	}
	&__cube2:before {
		-webkit-animation-delay: 0.3s;
		animation-delay: 0.3s;
	}
	&__cube3:before {
		-webkit-animation-delay: 0.6s;
		animation-delay: 0.6s;
	}
	&__cube4:before {
		-webkit-animation-delay: 0.9s;
		animation-delay: 0.9s;
	}
}

@keyframes foldCubeAnim {
	0%,
	10% {
		-webkit-transform: perspective(140px) rotateX(-180deg);
		transform: perspective(140px) rotateX(-180deg);
		opacity: 0;
	}
	25%,
	75% {
		-webkit-transform: perspective(140px) rotateX(0deg);
		transform: perspective(140px) rotateX(0deg);
		opacity: 1;
	}
	90%,
	100% {
		-webkit-transform: perspective(140px) rotateY(180deg);
		transform: perspective(140px) rotateY(180deg);
		opacity: 0;
	}
}

/*------------------------------------*\
  #INFINITY SCROLL SPINNER
\*------------------------------------*/
.spinner--infinity-scroll {
	--maxTranslateX: 120px;
	--dotSize: 18px;

	position: relative;
	display: flex;
	align-items: center;
	height: 18px;
	width: 140px;
	padding: 24px 0;
}

.spinner--infinity-scroll__dot {
	animation-name: dotMoveAnim;
	animation-timing-function: ease-in-out;
	animation-duration: 2s;
	animation-iteration-count: infinite;
	height: var(--dotSize);
	width: var(--dotSize);
	border-radius: 100%;
	background-color: black;
	position: absolute;
	border: 2px solid white;

	&:first-child {
		background-color: #ec1c24;
		animation-delay: 0.5s;
	}

	&:nth-child(2) {
		background-color: #296f0f;
		animation-delay: 0.4s;
	}

	&:nth-child(3) {
		background-color: #296f0f;
		animation-delay: 0.3s;
	}

	&:nth-child(4) {
		background-color: #009245;
		animation-delay: 0.2s;
	}

	&:nth-child(5) {
		background-color: #009245;
		animation-delay: 0.1s;
	}

	&:nth-child(6) {
		background-color: #8cc63f;
		animation-delay: 0s;
	}
}

/*------------------------------------*\
  #DOTS BUTTON SPINNER
\*------------------------------------*/
.spinner--buttons {
	--maxTranslateX: 12px;
	--dotSize: 8px;

	display: inline-flex;
	align-items: center;
	justify-content: center;

	&__dots {
		display: inline-flex;
		align-items: center;
		width: calc(var(--maxTranslateX) + var(--dotSize));
	}

	&__dot {
		animation-name: dotMoveAnim;
		animation-timing-function: ease-in-out;
		animation-duration: 3s;
		animation-iteration-count: infinite;
		height: var(--dotSize);
		width: var(--dotSize);
		border-radius: 100%;
		background-color: $white;
		position: absolute;

		&:first-child {
			background-color: $base;
			animation-delay: 0.3s;
		}

		&:nth-child(2) {
			background-color: $accent;
			animation-delay: 0.15s;
		}

		&:nth-child(3) {
			background-color: $white;
			animation-delay: 0s;
		}
	}
}

@keyframes dotMoveAnim {
	15% {
		transform: translateX(0);
	}
	45% {
		transform: translateX(var(--maxTranslateX));
	}
	65% {
		transform: translateX(var(--maxTranslateX));
	}
	95% {
		transform: translateX(0);
	}
}
</style>
